import React from 'react'
import PropTypes from 'prop-types'
import Die from '@mui/icons-material/CasinoOutlined'
import { activeAbilityGene, craftingGene, passiveAbilityGene } from '../../constants/dfk'

const StatGene = ({ gene }) => {
    const traitLevel = gene.trait.toLowerCase().substring(0, gene.trait.length - 1)
    const className = `value${traitLevel === 'basic' ? '' : ' highlighted'}`

    const traitIdentifier =
        traitLevel === 'basic' || traitLevel === 'advanced' ? (
            ''
        ) : (
            <div className="trait-identifier">({traitLevel})</div>
        )

    return (
        <div className="gene">
            <div className={className} title={`${gene.trait} : ${gene.description}`}>
                {gene.name} {traitIdentifier}
            </div>
        </div>
    )
}

const HeroSnapshotStatGenes = ({ className, hero }) => {
    const crafting1 = craftingGene[hero['crafting1']]
    const crafting2 = craftingGene[hero['crafting2']]
    const hasValidCraftingGenes = hero['hasValidCraftingGenes']
    // const element = genes['element'] ? genes['element'] : genes.statGenes['element']

    const active1 = activeAbilityGene[hero['active1']]
    const active2 = activeAbilityGene[hero['active2']]
    const passive1 = passiveAbilityGene[hero['passive1']]
    const passive2 = passiveAbilityGene[hero['passive2']]

    return (
        <>
            <div className={`hero-snapshot-genes${className ? ` ${className}` : ''}`}>
                <div className="title">Active</div>
                <StatGene gene={active1} />
                <StatGene gene={active2} />
            </div>
            <div className={`hero-snapshot-genes${className ? ` ${className}` : ''}`}>
                <div className="title">Passive</div>
                <StatGene gene={passive1} />
                <StatGene gene={passive2} />
            </div>
            <div className={`hero-snapshot-genes${className ? ` ${className}` : ''}`}>
                <div className="title">Crafting</div>
                {hasValidCraftingGenes ? (
                    <>
                        <StatGene gene={crafting1} />
                        <StatGene gene={crafting2} />
                    </>
                ) : (
                    <div class='icon' title='Reroll required'><Die /></div>
                )}
            </div>
            {/* 
            <div className={`hero-snapshot-genes${className ? ` ${className}` : ''}`}>
                <div className='title'>Element</div>
                <StatGene value={element} />
            </div> */}
        </>
    )
}

HeroSnapshotStatGenes.propTypes = {
    className: PropTypes.string,
    hero: PropTypes.object,
}

HeroSnapshotStatGenes.defaultProps = {}

export default HeroSnapshotStatGenes
